import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { roundFloat } from 'src/core/utils/formater';
import newAlert from 'src/components/newAlert';
import {
  Button,
  Form,
  Input,
  Row,
  Col,
  Divider,
  Modal,
} from 'antd';
import { start_loading, end_loading } from '../../../core/actions/loader';

export const AnglalModal = ({
  onCancel = () => {},
  visibleEdit = {
    visible: false,
    rowData: {},
  },
  seTvisibleEdit = () => {},
}) => {
  const dispatch = useDispatch();
  const { socket, data_date } = useSelector((state) => state);

  const [note, seTnote] = useState(null);
  const anglal = visibleEdit.rowData?.zuruu_iluu_niit_base > 0.1
  || visibleEdit.rowData?.zuruu_iluu_noat_base > 0.1;

  const [form] = Form.useForm();

  useEffect(() => {
    if (visibleEdit.visible) {
      if (note === null) {
        seTnote(visibleEdit.rowData?.note);
      }
    }
  }, [visibleEdit]);
  const onFinish = () => {
    socket.on('request_out', (req_data) => {
      socket.removeAllListeners('request_out');
      if (req_data.status === '0') {
        newAlert({ type: 'success', msg: req_data.message });
        seTvisibleEdit({
          visible: false,
          rowData: {},
        });
        seTnote(null);
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    });
    const row_data = {
      ...visibleEdit.rowData,
      note,
    };
    console.log(row_data);
    socket.emit('request_in', {
      channel: 'ss013_03_modify',
      content: {
        action_type: 'save_borluulalt',
        json_data: row_data,
        year: data_date?.year,

      },
    });
    dispatch(start_loading({}));
  };

  const onChangeHoishNiit = (e) => {
    const { value } = e.target;
    if (value) {
      const rowData = {
        ...visibleEdit.rowData,
        zuruu_dutuu_niit: visibleEdit.rowData?.zuruu_dutuu_niit_base - value,
        toh_hoish_niit: value,
      };
      seTvisibleEdit({ ...visibleEdit, rowData,
      });
    } else {
      const rowData = {
        ...visibleEdit.rowData,
        zuruu_dutuu_niit: visibleEdit.rowData?.zuruu_dutuu_niit_base,
        toh_hoish_niit: null,
      };
      seTvisibleEdit({ ...visibleEdit, rowData,
      });
    }
  };
  const onChangeHoishNoat = (e) => {
    const { value } = e.target;
    if (value) {
      const rowData = {
        ...visibleEdit.rowData,
        zuruu_dutuu_noat: visibleEdit.rowData?.zuruu_dutuu_noat_base - value,
        toh_hoish_noat: value,
      };
      seTvisibleEdit({ ...visibleEdit, rowData,
      });
    } else {
      const rowData = {
        ...visibleEdit.rowData,
        zuruu_dutuu_noat: visibleEdit.rowData?.zuruu_dutuu_noat_base,
        toh_hoish_noat: null,
      };
      seTvisibleEdit({ ...visibleEdit, rowData,
      });
    }
  };

  const onChangeIliiNiit = (e) => {
    const { value } = e.target;
    if (value) {
      const rowData = {
        ...visibleEdit.rowData,
        zuruu_iluu_niit: visibleEdit.rowData?.zuruu_iluu_niit_base - value,
        toh_iluu_niit: value,
      };
      seTvisibleEdit({ ...visibleEdit, rowData,
      });
    } else {
      const rowData = {
        ...visibleEdit.rowData,
        zuruu_iluu_niit: visibleEdit.rowData?.zuruu_iluu_niit_base,
        toh_iluu_niit: null,
      };
      seTvisibleEdit({ ...visibleEdit, rowData,
      });
    }
  };
  const onChangeIluuNoat = (e) => {
    const { value } = e.target;
    if (value) {
      const rowData = {
        ...visibleEdit.rowData,
        zuruu_iluu_noat: visibleEdit.rowData?.zuruu_iluu_noat_base - value,
        toh_iluu_noat: value,

      };
      seTvisibleEdit({ ...visibleEdit, rowData,
      });
    } else {
      const rowData = {
        ...visibleEdit.rowData,
        zuruu_iluu_noat: visibleEdit.rowData?.zuruu_iluu_noat_base,
        toh_iluu_noat: null,
      };
      seTvisibleEdit({ ...visibleEdit, rowData,
      });
    }
  };

  return (
    <Modal
      open={visibleEdit.visible}
      width="650px"
      footer={null}
      closable={false}
      maskClosable={false}
    >
      <div>
        <Row justify="start">
          <Col span={24}>
            <h2 style={{ fontWeight: 'bold' }}>НӨАТ тохируулах</h2>
          </Col>
        </Row>
        <Divider style={{ margin: '10px' }} />
        <Row>
          <Col span={24}>
            <Form
              form={form}
              className="register-form"
              size="small"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              initialValues={{ remember: true }}
            >
              <Form.Item
                label="Тэмдэглэл"
                labelAlign="left"
                className="ant-form-item-small"
                style={{ margin: '10px' }}
              >
                <Input className="ant-input" size="small" value={note} onChange={(e) => { seTnote(e.target.value); }} />
              </Form.Item>
              <Divider style={{ margin: '10px' }} />
              {!anglal
                ? (
                  <table className="ant-table custom-antd-table-one" style={{ tableLayout: 'fixed', margin: '10px' }}>
                    <tbody className="ant-table-tbody">
                      <tr className="ant-table-row ant-table-row-level-0 table-row-class">
                        <td className="ant-table-cell" style={{ width: '100px', margin: '10px' }} />
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px', fontWeight: 'bold' }}>Хойшлуулах</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px', fontWeight: 'bold' }}>Зөрүү дутуу</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px', fontWeight: 'bold' }}>Нийт </td>
                      </tr>
                      <tr className="ant-table-row ant-table-row-level-0 table-row-class">
                        <td className="ant-table-cell" style={{ width: '100px', margin: '10px' }}>Нийт дүн</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>
                          <Input type="number" className="ant-input" size="small" style={{ width: '130px' }} value={visibleEdit.rowData?.toh_hoish_niit} onChange={onChangeHoishNiit} />
                        </td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>{roundFloat(visibleEdit.rowData?.zuruu_dutuu_niit, 3)}</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>{roundFloat(visibleEdit.rowData?.zuruu_dutuu_niit_base, 3)}</td>
                      </tr>
                      <tr className="ant-table-row ant-table-row-level-0 table-row-class">
                        <td className="ant-table-cell" style={{ width: '100px', margin: '10px' }}>НӨАТ</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>
                          <Input type="number" className="ant-input" size="small" style={{ width: '130px' }} value={visibleEdit.rowData?.toh_hoish_noat} onChange={onChangeHoishNoat} />
                        </td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>{roundFloat(visibleEdit.rowData?.zuruu_dutuu_noat, 3)}</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>{roundFloat(visibleEdit.rowData?.zuruu_dutuu_noat_base, 3)}</td>
                      </tr>
                    </tbody>
                  </table>
                )
                : (
                  <table className="ant-table custom-antd-table-one" style={{ tableLayout: 'fixed', margin: '10px' }}>
                    <tbody className="ant-table-tbody">
                      <tr className="ant-table-row ant-table-row-level-0 table-row-class">
                        <td className="ant-table-cell" style={{ width: '100px', margin: '10px' }} />
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px', fontWeight: 'bold' }}>Илүү шивсэн</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px', fontWeight: 'bold' }}>Зөрүү илүү</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px', fontWeight: 'bold' }}>Нийт </td>
                      </tr>
                      <tr className="ant-table-row ant-table-row-level-0 table-row-class">
                        <td className="ant-table-cell" style={{ width: '100px', margin: '10px' }}>Нийт дүн</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>
                          <Input type="number" className="ant-input" size="small" style={{ width: '130px' }} value={visibleEdit.rowData?.toh_iluu_niit} onChange={onChangeIliiNiit} />
                        </td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>{roundFloat(visibleEdit.rowData?.zuruu_iluu_niit, 3)}</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>{roundFloat(visibleEdit.rowData?.zuruu_iluu_niit_base, 3)}</td>
                      </tr>
                      <tr className="ant-table-row ant-table-row-level-0 table-row-class">
                        <td className="ant-table-cell" style={{ width: '100px', margin: '10px' }}>НӨАТ</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>
                          <Input type="number" className="ant-input" size="small" style={{ width: '130px' }} value={visibleEdit.rowData?.toh_iluu_noat} onChange={onChangeIluuNoat} />
                        </td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>{roundFloat(visibleEdit.rowData?.zuruu_iluu_noat, 3)}</td>
                        <td className="ant-table-cell ant-table-cell-ellipsis" style={{ width: '150px', margin: '10px' }}>{roundFloat(visibleEdit.rowData?.zuruu_iluu_noat_base, 3)}</td>
                      </tr>
                    </tbody>
                  </table>
                )}
              <Row style={{ marginTop: 10 }}>
                <Col span={24} className="text-align-r">
                  <Form.Item noStyle>
                    <Button
                      onClick={() => {
                        seTvisibleEdit({
                          visible: false,
                          rowData: {},
                        });
                        seTnote(null);
                        onCancel();
                      }}
                      className="cancel-btn"
                      type="primary"
                      shape="round"
                    >
                      Буцах
                    </Button>
                    <Button
                      className="confirm-btn ml-5"
                      type="primary"
                      shape="round"
                      onClick={onFinish}
                    >
                      Хадгалах
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};
